import { defineMessages } from 'react-intl'

const scope = `procurify.components.BudgetCategoryAttributesCard`

export default defineMessages({
  budgetAttributesCardHeader: {
    id: `${scope}.budgetAttributesCardHeader`,
    defaultMessage: 'Budget Details',
  },
  secondaryOrgCategoryLabel: {
    id: `${scope}.secondaryOrgCategoryLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  accountCodesLabel: {
    id: `${scope}.accountCodesLabel`,
    defaultMessage: 'Account code',
  },
  viewersLabel: {
    id: `${scope}.viewers`,
    defaultMessage: 'Viewer',
  },
})
